export default __webpack_public_path__ + "static/media/hardwareLcd.e2715c84.png";